import styled, { createGlobalStyle } from 'styled-components/macro';
import reset from 'styled-reset';

import { tokens } from '@olist/design-system-tokens';

import { Footer } from 'components/general';

export const GlobalStyle = createGlobalStyle`
  ${reset}

  @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@600&display=swap');


  body {
    font-family:  ${tokens.fontFamily.soleil};
    line-height: 1.5;
  }

  b { font-weight: bold; }

  button { font-family:  ${tokens.fontFamily.soleil}; }
`;

const Container = styled.section`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: 100vh;
`;

export const PageLayout = ({ children }: { children?: JSX.Element }) => {
  return (
    <>
      <GlobalStyle />
      <Container>
        {children}
        <Footer />
      </Container>
    </>
  );
};
